// extracted by mini-css-extract-plugin
export default {"content":"src-components-CreateRedirectModal-create-redirect-modal-module__contentPDgsE"};